export default __webpack_public_path__ + "static/media/linkedin2.f0ba5777.png";